import { formatLongDate, formatShortDate } from 'Utils/FormatDate'

import { PLAN_TYPE, TIER } from '../../constants'

const CARD_TIERS = [TIER.ESSENTIALS, TIER.PREMIUM]

// Maps the BE plan change targets onto the two tier cards: the current card offers the other term,
// the other card leads with the current term.
export default function buildTierCards({ tier, billingTerm, targets }) {
  const availableTargets = targets.filter((target) => target.available)

  return CARD_TIERS.map((cardTier) => {
    const current = cardTier === tier
    const options = availableTargets.filter((target) => target.tier === cardTier)
    const action = options.find((target) => target.billingTerm === billingTerm) || options[0] || null

    return {
      tier: cardTier,
      current,
      showAnnualPrice: !current && billingTerm === PLAN_TYPE.ANNUAL && action?.billingTerm === PLAN_TYPE.ANNUAL,
      action,
    }
  })
}

// The design drops the year for dates in the current year ("Jun 26") and keeps it otherwise.
export function formatChangeDate(date, locale) {
  const isThisYear = new Date(date).getUTCFullYear() === new Date().getUTCFullYear()
  return isThisYear ? formatShortDate(date, locale, 'UTC') : formatLongDate(date, locale, 'UTC')
}
